<template>
	<v-client-table
		v-model="aspects"
		:columns="fields"
		:options="options"
	>
		<router-link
			slot="edit"
			slot-scope="aspects"
			class="nav-item"
			:to="`/aspect/${aspects.row.aspect_id}`"
		>Edit</router-link>
	</v-client-table>
</template>

<script>
import tableFields from '@/components/AspectTable/tableFields'

export default {
	props: ['aspects'],
	name: "AspectTableList",
	data() {
		return {
			fields: tableFields,
			options: {
				resizableColumns: false,
				perPage: 10,
				perPageValues: [],
				filterable: false,
				highlightMatches: false,
				filterByColumn: false,
				skin: '',
				hiddenColumns: ['id'],
				headings: {
					delete: false,
					edit: false
				}
			}
		}
	},
}
</script>

<style scoped>

</style>